import { applyMiddleware, combineReducers, createStore } from 'redux';
import ProjectInfor from './Reducer/ProjectInfor'
import ThemeReducer from './Reducer/ThemeReducer'
const rootReducer = combineReducers({
    ProjectInfor,
    ThemeReducer
})


export default rootReducer